import { Icon, Skeleton } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React, { Fragment } from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { getFlex } from '../utils';

import { InvestmentStrategyListEmptyTypes } from './types';

const createSkeleton = (fullWidth: boolean = true) => (
  <Skeleton width={fullWidth ? '100%' : '70%'} height="inline.xxxs" borderRadius="sm" />
);

const InvestmentStrategyListEmptyMobileBase: React.FC<
  InvestmentStrategyListEmptyTypes.Props
> = () => {
  const loadingSize = 3;
  return Array(loadingSize)
    .fill(() => undefined)
    .map((_, index) => (
      <Fragment key={index.toString()}>
        <TableContent
          direction="row"
          space={Spacing['stack.xxs']}
          py={Spacing['stack.xxs']}
          px={Spacing['inline.xxxs']}
          spaceX={Spacing['inline.xxxs']}>
          {Array(2)
            .fill(0)
            .map((__, i) => (
              <TableContentItemColumn key={i.toString()} flex={getFlex(i)}>
                <TableContentItemText>{createSkeleton()}</TableContentItemText>
                <TableContentItemText>{createSkeleton(false)}</TableContentItemText>
              </TableContentItemColumn>
            ))}
          <TableContentItemColumn flex="none">
            <Icon name="ChevronDown" size="xs" />
          </TableContentItemColumn>
        </TableContent>
        {index !== loadingSize - 1 && <Box h={Spacing['inset.xs']} width="100%" />}
      </Fragment>
    ));
};

export const InvestmentStrategyListEmptyMobile = React.memo(InvestmentStrategyListEmptyMobileBase);
